module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_home_color_black-a1d4be04db250ab1ca533d7b955e1b54.svg";